export default "__VITE_ASSET__XL3fRQJa__"